"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _tooltip = _interopRequireDefault(require("../../../../core/tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null, "Date"), /*#__PURE__*/_react.default.createElement("th", {
  className: "hidden-print"
}, "Who refunded?"), /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, " Refunded By Club"), /*#__PURE__*/_react.default.createElement("th", null)));
class Refunds extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_getStatusClass", refundStatusRef => {
      if (refundStatusRef === 'RFND') return 'text-xs-right text-success';
      if (refundStatusRef === 'RVRT') return 'text-xs-right text-success';
      if (refundStatusRef === 'ERRR') return 'text-xs-right text-danger';
      return 'text-xs-right';
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card card-block"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.refunds.map(refund => /*#__PURE__*/_react.default.createElement("tr", {
      key: refund.id
    }, /*#__PURE__*/_react.default.createElement("td", null, this.props.displayDateTime(refund.refundDate)), /*#__PURE__*/_react.default.createElement("td", {
      className: "hidden-print"
    }, refund.refundedByUserEmail), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, (0, _gbp.default)(refund.refundedByClub)), refund.refundStatusRef === 'ERRR' && refund.errorMessage ? /*#__PURE__*/_react.default.createElement(_tooltip.default, {
      placement: "topLeft",
      overlay: refund.errorMessage
    }, /*#__PURE__*/_react.default.createElement("td", {
      className: this._getStatusClass(refund.refundStatusRef)
    }, " ", refund.refundStatusDescription)) : /*#__PURE__*/_react.default.createElement("td", {
      className: this._getStatusClass(refund.refundStatusRef)
    }, " ", refund.refundStatusDescription))))));
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(Refunds, "partialQueries", {
  Refunds: {
    id: true,
    refundedByClub: true,
    refundDate: true,
    refundedByUserEmail: true,
    refundStatusRef: true,
    refundStatusDescription: true,
    errorMessage: true
  }
});
var _default = exports.default = Refunds;